import * as React from "react";
const SvgSearch = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.513 15.308a6.926 6.926 0 1 1 9.795-9.795 6.926 6.926 0 0 1 0 9.795l-.01.01a6.927 6.927 0 0 1-9.785-.01Zm10.302 1.567A8.428 8.428 0 0 1 4.452 4.452a8.427 8.427 0 0 1 12.424 11.363l4.92 4.92a.75.75 0 1 1-1.06 1.061l-4.921-4.92Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgSearch;
